import { Box, Flex, Text, useColorMode, useColorStyle } from '@tonic-one/react';
import newFeature from '../../../../assets/image/new-feature.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
export default () => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return (
    <Box m="160px 96px">
      <Flex justifyContent="center" alignItems="center">
        <Flex width="545px">
          <Box flex="auto" width="545px" height="286px">
            <Flex flexDirection="column" textAlign="center">
              <Box mb="24px">
                <img width="192px" height="192px" src={newFeature} />
              </Box>
              <Text
                fontSize="16px"
                fontWeight={600}
                lineHeight="22px"
                color={colorStyle.color.primary}
              >
                {t('welcome.blockingPage.notAvailable.title')}
              </Text>
            </Flex>
            <Flex
              flexDirection="column"
              mt={8}
              fontSize="14px"
              fontWeight={400}
              lineHeight="20px"
              color={colorStyle.color.secondary}
            >
              <Text mb={8}>{t('welcome.blockingPage.notAvailable.desc')}</Text>
              <Box as="ul" p="0px 0px 0px 20px">
                <Box as="li">
                  <Text>{t('welcome.blockingPage.notAvailable.blockLmp')}</Text>
                </Box>
                <Box as="li">
                  <Text>{t('welcome.blockingPage.notAvailable.p1')}</Text>
                </Box>
              </Box>
            </Flex>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};
